import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { PrintHelpers } from '../../../components'
const borderStyle = { border: '1px solid #424242', paddingTop: '10px' }
export const TicketPrintReport = ({
  ticket,
}) => {
  const { organization, device, customer, unit_part_reports, terms } = ticket

  return (
    <ReactBootstrap.Row className="p-2 print_zone">
      <ReactBootstrap.Row className="pl-5 pr-5">
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Header
            legend="Service Report"
            organization={organization}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.EaseOnBarcode value={ticket.reference_number} />
          {ticket.po_number && <PrintHelpers.InlineText
              label="PO Number"
              lineBreakAfterLabel={true}
              value={ticket.po_number}
          />
          }

        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          {ticket.drop_off_time && <PrintHelpers.TimeStamp
            label="Drop Off Time"
            value={ticket.drop_off_time}
            />
          }
          <PrintHelpers.TimeStamp
            label="Inward Time"
            value={ticket.inward_time || ticket.created_at}
          />
          <PrintHelpers.TimeStamp
            label="Expected Delivery Time"
            value={ticket.expected_delivery_time}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>

          <PrintHelpers.Device label="Device Information" value={device} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Organization
            label="Authorised Service Provider"
            value={organization}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>

          <PrintHelpers.Customer
            label="Customer Information"
            value={customer}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Label value="Issue Reported By Customer" />

          <PrintHelpers.PrintText value={ticket.issue_reported_by_customer} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.Label value={'Inward Details'} />
          <PrintHelpers.InlineText
            label="Service Type"
            lineBreakAfterLabel={true}
            value={ticket.coverage_type}
          />
          <PrintHelpers.InlineText
            label="Repair Type"
            lineBreakAfterLabel={true}
            value={ticket.repair_type}
          />
          <PrintHelpers.InlineText
            label="Stand By Device"
            value={ticket.is_standby_device_required ? 'Yes' : 'No'}
          />

          <PrintHelpers.InlineText
            label="Accessories Received"
            lineBreakAfterLabel={true}
            value={ticket.accessories}
          />
          <PrintHelpers.InlineText
            label="Required Upgrades"
            lineBreakAfterLabel={true}
            value={ticket.required_upgrades}
          />
          <PrintHelpers.InlineText
            label="Unit Condition"
            lineBreakAfterLabel={true}
            value={ticket.device_condition}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={6}>
          <PrintHelpers.DevicePartReport
            label="Device Part Information"
            reports={unit_part_reports}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            label="Token Number"
            lineBreakAfterLabel={true}
            value={ticket.customer.token_number}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            label="Operating System"
            lineBreakAfterLabel={true}
            value={ticket.initial_operating_system}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            label="Backup Required"
            lineBreakAfterLabel={true}
            value={ticket.is_backup_required ? 'Yes' : 'No'}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            isCurrency={true}
            label="Expected Service/Diagnosis Cost"
            lineBreakAfterLabel={true}
            value={ticket.expected_service_cost}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            isCurrency={true}
            label="Expected Hardware Cost"
            value={ticket.expected_hardware_cost}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={4}>
          <PrintHelpers.InlineText
            isCurrency={true}
            label="Total Cost"
            value={ticket.expected_hardware_cost + ticket.expected_service_cost}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} xs={12}>
          <PrintHelpers.Terms label="Important" value={terms} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} className="text-left" xs={6}>
          <PrintHelpers.Signature signature={ticket.created_by_signature} />
          <PrintHelpers.InlineText value={ticket.created_by} />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col style={borderStyle} className="text-end" xs={6}>
          <PrintHelpers.Signature signature={ticket.customer_signature2} />
          <PrintHelpers.InlineText value={'Customer Signature'} />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </ReactBootstrap.Row>
  )
}
